<template>
    <div>
        <form class="py-12" v-on:submit.prevent="prevent" autocomplete="null">
            <v-slide-x-transition>
                <v-card class="mx-auto my-3" :loading="loading" max-width="768">
                    <!-- :loading="loading" -->
                    <v-card-title>
                        <!-- {{ $t('register.steps.user.title')}} -->
                    </v-card-title>
                    <v-card-text>
                        <v-row>

                            <v-col cols="12" md="6" sm="12">
                                <v-text-field v-model="form.name" counter="30" :error-messages="nameErrors"
                                    :label="$t('register.steps.user.form.name.label')" required
                                    @input="v$.form.name.$touch()" @blur="v$.form.name.$touch()"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6" sm="12">
                                <v-text-field :loading="checkerLoading.email" autocomplete="null" type="email"
                                    v-model="form.email" :error-messages="emailErrors"
                                    :label="$t('register.steps.user.form.email.label')" required
                                    @input="v$.form.email.$touch()" @blur="v$.form.email.$touch()">
                                    <v-icon slot="append" color="green"
                                        v-if="(available.email === true && !emailErrors.length)">
                                        mdi-check
                                    </v-icon>
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <!-- <v-col cols="12" md="4" sm="12" v-if="!switchForm">
                            <v-text-field :loading="checkerLoading.document" v-model="form.personalDocument"
                                :counter="assets.countries[this.country].personalDocumentMask.length"
                                :error-messages="personalDocumentErrors" v-mask="documentMask"
                                :label="`${assets.countries[this.country].personalDocument}*`" required
                                @input="v$.form.personalDocument.$touch()" @blur="v$.form.personalDocument.$touch()">
                                <v-icon slot="append" color="green" v-if="available.document === true">
                                    mdi-check
                                </v-icon>
                            </v-text-field>
                        </v-col> -->
                            <!-- <v-col cols="12" :md="switchForm ? 6 : 4" sm="12">
                            <v-text-field v-model="form.role" v-if="switchForm"
                                :label="$t('register.steps.user.form.role.label')" 
                                >
                            </v-text-field>
                            <v-text-field v-else v-model="form.role" :error-messages="roleErrors"
                                :label="`${$t('register.steps.user.form.role.label')}*`" required
                                @input="v$.form.role.$touch()" @blur="v$.form.role.$touch()">
                            </v-text-field>
                        </v-col> -->

                            <v-col cols="12" md="6" sm="12">
                                <v-select :items="assets.countries"
                                    :label="$t('register.steps.user.form.country.label')" item-value="index"
                                    item-text="name" v-model="ncountry">
                                    <template #append>
                                        <v-img max-width="22" max-height="22" style="margin: 4px 8px 0 -5px;" contain
                                            :src="require(`@/assets/flags/${assets.countries[country].flag}`)"></v-img>
                                    </template>
                                    <template v-slot:item="slotProps">
                                        <v-img max-width="22" max-height="22" class="mr-3" contain
                                            :src="require(`@/assets/flags/${slotProps.item.flag}`)"></v-img>
                                        {{ slotProps.item.name }}
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12" :md="switchForm ? 6 : 6" sm="12">
                                <v-text-field autocomplete="nope" type="search" id="inpt01" v-model="form.phone"
                                    :error-messages="phoneErrors" :placeholder="phonePlaceholder" v-mask="phoneMask"
                                    :label="$t('register.steps.user.form.phone.label')" required
                                    @input="v$.form.phone.$touch()" @blur="v$.form.phone.$touch()"></v-text-field>
                            </v-col>

                        </v-row>
                        <v-row>
                            <v-col cols="12" md="6" sm="12" class="--password">
                                <v-text-field autocomplete="null" v-model="form.password" counter="20"
                                    :messages="passwordMessages" :error-messages="passwordErrors"
                                    :label="$t('register.steps.user.form.password.label')" required
                                    :type="showPassword ? 'text' : 'password'"
                                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    @click:append="showPassword = !showPassword" @input="v$.form.password.$touch()"
                                    @blur="v$.form.password.$touch()" @keyup.enter="$refs.confirm.$el.focus()">
                                </v-text-field>
                                <v-menu offset-y v-model="menuPassword" left :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn color="primary" icon v-bind="attrs" class="--password-info"
                                            v-on:mouseover="on" @mouseover="menuPassword = true">
                                            <v-icon size="22">mdi-information</v-icon>
                                        </v-btn>

                                    </template>
                                    <v-card color="white" class="pa-2">
                                        <v-card-text>
                                            <p><strong>{{
                                                $t('register.steps.user.form.password.safety.title')}}</strong></p>
                                            <ul class="--password-info-elements" style="padding: 0">
                                                <li style="font-size: 13px; list-style: none;"
                                                    v-for="(element, i) in passwordElements" :key="i"
                                                    :class="`${element.config[1]}--text`">
                                                    <v-icon :color="element.config[1]">{{ element.config[0] }}</v-icon>
                                                    {{
                                                        element.title
                                                    }}
                                                </li>
                                            </ul>

                                            <p>aplique ao menos 3 critérios</p>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                                <password-meter :password="form.password" @score="onScore($event)"></password-meter>

                            </v-col>
                            <v-col cols="12" md="6" sm="12">
                                <v-text-field autocomplete="null" ref="confirm" v-model="form.confirm"
                                    :error-messages="confirmErrors"
                                    :label="$t('register.steps.user.form.confirm.label')" required
                                    :type="showPasswordConfirm ? 'text' : 'password'"
                                    :append-icon="showPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                                    @click:append="showPasswordConfirm = !showPasswordConfirm"
                                    @input="v$.form.confirm.$touch()" @blur="v$.form.confirm.$touch()"
                                    @keyup.enter="submit"></v-text-field>
                            </v-col>
                        </v-row>

                        <turnstile-widget v-model="turnstileToken" class="mt-2"></turnstile-widget>
                    </v-card-text>
                    <v-card-actions class="d-flex justify-end py-3">
                        <div class="d-flex justify-end align-center py-2" style="width: 100%">
                            <v-btn class="mr-2 white--text" color="green" elevation="0" type="button"
                                :loading="processing" :disabled="disabled" @click="submit()">
                                {{ $t('register.steps.buttons.next') }} <v-icon class="ml-6">mdi-arrow-right</v-icon>
                            </v-btn>
                        </div>
                    </v-card-actions>
                </v-card>
            </v-slide-x-transition>
        </form>
        <v-dialog v-model="recovery" width="600">
            <auth-recovery v-if="recovery" :user="{ email: this.form.email }" @responseToken="hashByCode = $event"
                type="authorizer"></auth-recovery>
        </v-dialog>
    </div>
</template>
<script>
import useVuelidate from '@vuelidate/core'
import { required, minLength, maxLength, email, sameAs } from '@vuelidate/validators'
import passwordMeter from "vue-simple-password-meter";
import AuthRecovery from '../auth/AuthRecovery.vue';
import TurnstileWidget from '../auth/TurnstileWidget.vue';

export default {
    components: {
        passwordMeter,
        AuthRecovery,
        TurnstileWidget
    },
    setup() {
        return { v$: useVuelidate() }
    },
    props: {
        assets: {
            type: Object,
        },
        country: {
            type: Number
        }
    },
    data: () => ({
        hashByCode: null,
        recovery: false,
        menuPassword: false,
        passwordScore: null,
        checkerLoading: {
            email: false,
            document: false
        },
        checkerTimeout: {
            email: null,
            document: null
        },
        available: {
            email: null,
            document: null
        },
        passswordScore: null,
        showPassword: false,
        showPasswordConfirm: false,
        processing: false,
        loading: false,
        ncountry: 0,
        switchForm: '',
        form: {
            name: '',
            email: '',
            // personalDocument: '',
            // role: '',
            phone: '',
            password: '',
            confirm: '',
        },
        errors: {
            document: [],
            email: []
        },
        turnstileToken: ''
    }),


    validations() {

        let f = {
            form: {
                name: { required, minLength: minLength(3), maxLength: maxLength(30) },
                email: { required, email },
                // role: { required },
                // personalDocument: { required, minLength: minLength(this.assets.countries[this.country].personalDocumentMask.length) },
                phone: { required, minLength: minLength(this.assets.countries[this.country].phoneMinLength) },
                password: { required, minLength: minLength(6), maxLength: maxLength(20) },
                confirm: { required, sameAs: sameAs(this.form.password) },
            }
        }
        if (this.switchForm) {
            delete f.form.role
            delete f.form.personalDocument
        }

        return f
    },
    mounted() {
        console.log('this.country', this.country)
        this.ncountry = this.country
        this.switchForm = this.$route.params.p ? this.$route.params.p : ""

    },

    computed: {
        disabled() {
            return this.v$.form.$errors.length > 0 || (this.v$.form.password.$dirty && this.passwordScore < 2) || this.errors.email.length > 0 || this.errors.document.length > 0 || !this.turnstileToken
        },
        phoneMask() {
            const result = this.assets.countries[this.country].phoneMasks
            if (this.assets.countries[this.country].code == 'PER' && this.form.phone[4] == 1) {
                return '+51 # ### ## ##'
            }
            if (this.assets.countries[this.country].code == 'PER' && this.form.phone[4] == 9) {
                return '+51 ### ### ###'
            }
            if (this.assets.countries[this.country].code == 'CHI' && this.form.phone[4] == 2) {
                return '+56 # ##-###-###'
            }
            if (this.assets.countries[this.country].code == 'CHI' && this.form.phone[4] == 9) {
                return '+56 # ####-####'
            }
            return result
        },
        phonePlaceholder() {
            return this.assets.countries[this.country].phonePlaceholder
        },
        documentMask() {
            const result = this.assets.countries[this.country].personalDocumentMask
            return result
        },
        nameErrors() {
            const errors = []
            if (!this.v$.form.name.$dirty) return errors
            this.v$.form.name.minLength.$invalid && errors.push(this.$t('register.steps.user.form.name.errors.minLength', { count: 3 }))
            this.v$.form.name.maxLength.$invalid && errors.push(this.$t('register.steps.user.form.name.errors.maxLength', { count: 30 }))
            this.v$.form.name.required.$invalid && errors.push(this.$t('register.steps.user.form.name.errors.required'))
            return errors
        },
        emailErrors() {
            const errors = []
            if (!this.v$.form.email.$dirty) return errors
            this.v$.form.email.email.$invalid && errors.push(this.$t('register.steps.user.form.email.errors.email'))
            this.v$.form.email.required.$invalid && errors.push(this.$t('register.steps.user.form.email.errors.required'))
            this.errors.email.forEach((error) => {
                errors.push(this.$t(error))
            })
            return errors
        },
        // personalDocumentErrors() {
        //     const errors = []
        //     if (!this.switchForm) {
        //         this.errors.document.forEach((error) => {
        //             errors.push(this.$t(error, { doc: this.assets.countries[this.country].personalDocument }))
        //         })
        //         if (!this.v$.form.personalDocument.$dirty) return errors
        //         this.v$.form.personalDocument.required.$invalid && errors.push(this.$t('register.steps.user.form.document.errors.required', { doc: this.assets.countries[this.country].personalDocument }))
        //         this.v$.form.personalDocument.minLength.$invalid && errors.push(this.$t('register.steps.user.form.document.errors.minLength', { doc: this.assets.countries[this.country].personalDocument, count: this.assets.countries[this.country].personalDocumentMask.length }))
        //     }
        //     return errors
        // },
        phoneErrors() {
            const errors = []
            if (!this.v$.form.phone.$dirty) return errors
            this.v$.form.phone.required.$invalid && errors.push(this.$t('register.steps.user.form.phone.errors.required'))
            this.v$.form.phone.minLength.$invalid && errors.push(this.$t('register.steps.user.form.phone.errors.minLength', { count: this.assets.countries[this.country].phoneMinLength }))
            return errors
        },
        // roleErrors() {
        //     const errors = []
        //     if (!this.switchForm) {
        //         if (!this.v$.form.role.$dirty) return errors
        //         this.v$.form.role.required.$invalid && errors.push(this.$t('register.steps.user.form.role.errors.required'))
        //     }
        //     return errors
        // },
        passwordErrors() {
            const errors = []
            if (!this.v$.form.password.$dirty) return errors
            this.v$.form.password.minLength.$invalid && errors.push(this.$t('register.steps.user.form.password.errors.minLength', { count: 6 }))
            this.v$.form.password.maxLength.$invalid && errors.push(this.$t('register.steps.user.form.password.errors.maxLength', { count: 20 }))
            this.v$.form.password.required.$invalid && errors.push(this.$t('register.steps.user.form.password.errors.required'))
            this.passwordScore < 2 && errors.push(this.$t('register.steps.user.form.password.errors.unsafe'))
            return errors
        },
        confirmErrors() {
            const errors = []
            if (!this.v$.form.confirm.$dirty) return errors
            this.v$.form.confirm.sameAs.$invalid && errors.push(this.$t('register.steps.user.form.confirm.errors.sameAs'))
            this.v$.form.confirm.required.$invalid && errors.push(this.$t('register.steps.user.form.confirm.errors.required'))
            return errors
        },
        passwordMessages() {
            const messages = []
            if (this.passwordScore < 2) {
                return messages
            }
            this.passwordScore == 1 && messages.push(this.$t('register.steps.user.form.confirm.errors.weakPass'))
            this.passwordScore == 2 && messages.push(this.$t('register.steps.user.form.confirm.errors.moderatePass'))
            this.passwordScore == 3 && messages.push(this.$t('register.steps.user.form.confirm.errors.securityPass'))
            this.passwordScore == 4 && messages.push(this.$t('register.steps.user.form.confirm.errors.strongPass'))
            return messages
        },
        passwordElements() {
            const list = [
                { title: this.$t('register.steps.user.form.password.safety.uppercaseIsRequired'), config: [] }, // Conter letra maiúscula
                { title: this.$t('register.steps.user.form.password.safety.lowercaseIsRequired'), config: [] }, // 'Conter letra minúscula'
                { title: this.$t('register.steps.user.form.password.safety.numberIsRequired'), config: [] }, // 'Conter número'
                { title: this.$t('register.steps.user.form.password.safety.specialCharacterIsRequired'), config: [] }, // Conter caractere especial
                { title: this.$t('register.steps.user.form.password.safety.lengthIsRequired', { count: 8 }), config: [] } // Ao menos X caracteres
            ]
            const errIcon = 'mdi-checkbox-blank-outline'
            const okIcon = 'mdi-checkbox-marked'
            const str = this.form.password
            list[0].config = (/[A-Z]/.test(str)) ? [okIcon, 'green'] : [errIcon, 'grey']
            list[1].config = (/[a-z]/.test(str)) ? [okIcon, 'green'] : [errIcon, 'grey']
            list[2].config = (/[0-9]/.test(str)) ? [okIcon, 'green'] : [errIcon, 'grey']
            list[3].config = (/[!@#$%^&*(),.?":{}|<>]/g.test(str)) ? [okIcon, 'green'] : [errIcon, 'grey']
            list[4].config = str.length > 7 ? [okIcon, 'green'] : [errIcon, 'grey']

            return list
        }
    },
    watch: {
        hashByCode: {
            deep: true,
            handler(value) {
                console.log('value', value)
                this.$emit('set-hash', value)
            }
        },
        ncountry: {
            immediate: true,
            handler(val) {
                this.$emit('change-country', val)
                this.showPhone = false
                console.log('reseting phone...')
                this.form.phone = ""
            }
        },
        country: {
            immediate: true,
            handler(val) {
                this.ncountry = this.country
                this.$emit('change-country', val)
                this.showPhone = false
                console.log('reseting phone...')
                this.form.phone = ""
            }
        },
        // 'form.personalDocument'(v) {
        //     this.errors.document = []
        //     if (!this.v$.form.personalDocument.$invalid) {
        //         if (this.checkerTimeout.document)
        //             clearTimeout(this.checkerTimeout.document)
        //         this.checkerTimeout.document = setTimeout(() => {
        //             this.checker('document', v, 'documentId')
        //             this.checkerTimeout.document = null
        //         }, 1000)
        //     }
        //     else {
        //         this.available.document = null
        //     }
        // },
        'form.email'(v) {
            this.errors.email = []
            if (!this.v$.form.email.email.$invalid) {
                if (this.checkerTimeout.email)
                    clearTimeout(this.checkerTimeout.email)
                this.checkerTimeout.email = setTimeout(() => {
                    this.checker('email', v)
                    this.checkerTimeout.email = null
                }, 1000)
            }
            else {
                this.available.email = null
            }
        },
        'form.personalDocument'(v) {
            this.errors.document = []
            if (!this.v$.form.personalDocument.$invalid) {
                if (this.checkerTimeout.document)
                    clearTimeout(this.checkerTimeout.document)
                this.checkerTimeout.document = setTimeout(() => {
                    this.checker('document', v, 'documentId')
                    this.checkerTimeout.document = null
                }, 1000)
            }
            else {
                this.available.document = null
            }
        }
    },
    methods: {
        checker(field, value, toCheck = null) {
            if (!toCheck)
                toCheck = field
            this.checkerLoading[field] = true
            this.$axios.post(`assets/checker/${toCheck}`, { value: value, input: toCheck }).then((res) => {
                this.checkerLoading[field] = false
                if (field == 'email' && !res.data.data.available) {
                    this.recovery = true;
                }
                if (!res.data.data.available) {
                    this.errors[field].push(`register.steps.user.form.${field}.errors.unavailable`)

                }
                this.available[field] = res.data.data.available
            }, err => {
                this.checkerLoading[field] = false
                console.error('ERR', err)
            })
        },
        onScore(score) {
            this.passwordScore = score.score
        },
        prevent(event) {
            event.stopPropagation()
        },
        submit() {
            this.v$.$touch()
            if (!this.v$.$invalid && !this.processing) {
                this.processing = true

                const Form = {
                    location: this.assets.countries[this.country].code,
                    contacts: [{ type: 2, contact: this.form.phone, text: "" }],
                    // document: this.form.personalDocument,
                    language: this.$i18n.locale,
                    email: this.form.email,
                    // jobDescription: this.form.role,
                    name: this.form.name,
                    // documentType: this.assets.countries[this.country].personalDocument,
                    password: this.form.password,
                    passwordConfirm: this.form.confirm,
                    partner: this.$route.params.p ? this.$route.params.p : null,
                    turnstileToken: this.turnstileToken
                }
                this.$axios.post(`portal/register`, Form).then((response) => {
                    var dataLayer = []
                    dataLayer.push({
                        'event': 'AllSignupSuccess'
                    });
                    window.dataLayer.push({
                        'event': 'AllSignupSuccess'
                    })
                    this.$emit('set-hash', { hash: response.data.data.hash, interaction: response.data.data.interaction, phone: this.form.phone })
                    this.processing = false
                }

                    , (err) => {
                        const error = err.response.data.errors
                        if (error[0][0] == 'errors.document.invalid') {
                            this.errors.document.push('register.steps.user.form.document.errors.invalid')
                        }
                        if (error[0].hasOwnProperty('document')) {
                            this.errors.document.push('register.steps.user.form.document.errors.unavailable')
                        }
                        if (error[0].hasOwnProperty('email')) {
                            this.errors.email.push('register.steps.user.form.email.errors.unavailable')
                        }
                        if (error.length && error[0].hasOwnProperty('timeout')) {
                            this.$emit('set-generic-error', 'register.token.expired')
                        }
                        else if (error.length && error[0].hasOwnProperty('turnstileToken')) {
                            this.$emit('set-generic-error', 'register.token.captchaInvalid')
                        }
                        else {
                            console.error('An error found', error)
                        }
                        this.processing = false

                    })
            }
            else {
                this.processing = false
            }
        }
    }
}
</script>
<style lang="scss">
.--password {
    position: relative;

    .v-text-field__details {
        width: calc(100% - 30px);
    }

    .--password-info {
        position: absolute;
        top: 60px;
        right: 5px;
    }
}
</style>